import { BrowserUtils } from '~/utils/BrowserUtils';

export const useCanShowInFinderOption = () => {
  return {
    canShowOpenInFinder: BrowserUtils.isMacOS(),
  };
};
